// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#chatform .message {\n  position: relative;\n  white-space: pre-wrap;\n}", "",{"version":3,"sources":["webpack://./src/client/element/message/MessageElement.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qBAAA;AACF","sourcesContent":["#chatform .message {\n  position: relative;\n  white-space: pre-wrap;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
